var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "financeApplication__form" },
    [
      _c("ValidationProvider", {
        attrs: { name: "income", rules: _vm.validationRules, slim: "" },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (ref) {
              var validate = ref.validate
              var errors = ref.errors
              return [
                _c(
                  "div",
                  { class: _vm.classNames },
                  [
                    _c(
                      "FinanceApplicationRow",
                      {
                        attrs: {
                          id: "salary",
                          label: "Income (£s)",
                          "error-message": errors[0],
                        },
                      },
                      [
                        _c("FinanceApplicationText", {
                          attrs: {
                            type: "number",
                            id: "salary",
                            placeholder: "Enter monthly income after tax",
                          },
                          on: {
                            input: function ($event) {
                              return _vm.onChange($event, validate)
                            },
                          },
                          model: {
                            value: _vm.employment.salary,
                            callback: function ($$v) {
                              _vm.$set(_vm.employment, "salary", $$v)
                            },
                            expression: "employment.salary",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }